export const countries = [
  {
    label: 'FRANCE',
    value: '2'
  },
  {
    label: 'BELGIQUE',
    value: '3'
  },
  {
    label: 'BULGARIE',
    value: '54'
  },
  {
    label: 'CROATIE',
    value: '10'
  },
  {
    label: 'BOSNIE HERZEGONVINE',
    value: '52'
  },
  {
    label: 'ITALIE',
    value: '11'
  },
  {
    label: 'ESPAGNE',
    value: '19'
  },
  {
    label: 'PORTUGAL',
    value: '15'
  },
  {
    label: 'SUISSE',
    value: '17'
  },
  {
    label: 'LUXEMBOURG',
    value: '18'
  },
  {
    label: 'MONACO',
    value: '37'
  },
  {
    label: 'REPUBLIQUE TCHEQUE',
    value: '351'
  },
  {
    label: 'SLOVAQUIE',
    value: '435'
  },
  {
    label: 'UKRAINA',
    value: '90'
  },  
  {
    label: 'Brazil',
    value: '45'
  },

];

export const countries_ba = [
  {
    label: 'BOSNA HERCEGONVINA',
    value: '52'
  }
];

export const countries_bg = [
  {
    label: 'BULGARIYA',
    value: '54'
  }
];

export const countries_de = [
  {
    label: 'GERMANY',
    value: '8'
  },
  {
    label: 'AUSTRIA',
    value: '47'
  },
  {
    label: 'SWITZERLAND',
    value: '17'
  }
];

export const countries_pl = [
  {
    label: 'Polska',
    value: '14'
  }
];

export const countries_be = [
  {
    label: 'PAYS-BAS',
    value: '12'
  },
  {
    label: 'BELGIQUE',
    value: '3'
  },
  {
    label: 'LUXEMBOURG',
    value: '18'
  }
];

export const countries_nl = [
  {
    label: 'NEDERLAND',
    value: '12'
  },
  {
    label: 'BELGIË',
    value: '3'
  },
  {
    label: 'LUXEMBURG',
    value: '18'
  }
];

export const countries_hr = [
  {
    label: 'HRVATSKA',
    value: '10'
  }
];

export const countries_hu = [
  {
    label: 'MAGYARORSZAG',
    value: '64'
  }
];

export const countries_cz = [
  {
    label: 'Česká republika',
    value: '351'
  },
  {
    label: 'Slovensko',
    value: '435'
  }
];

export const countries_lv_lt = [
  {
    label: 'Latvija',
    value: '96'
  },
  {
    label: 'Estija',
    value: '60'
  },
  {
    label: 'Lietuva',
    value: '97'
  }
];

export const countries_ee = [
  {
    label: 'Läti',
    value: '96'
  },
  {
    label: 'Eesti',
    value: '60'
  },
  {
    label: 'Leedu',
    value: '97'
  }
];

export const countries_dk_se_fi_no = [
  {
    label: 'Danmark',
    value: '491'
  },
  /*{
    label: 'Finland',
    value: '16'
  },
  {
    label: 'Norge',
    value: '9'
  },
  {
    label: 'Sverige',
    value: '86'
  }*/
];

export const countries_se = [
  {
    label: 'Sverige',
    value: '86'
  }
];

export const countries_no = [
  {
    label: 'Norge',
    value: '9'
  }
];

export const countries_fi = [
  {
    label: 'Finland',
    value: '16'
  }
];

export const countries_es = [
  {
    label: 'España',
    value: '19'
  },
  {
    label: 'Andorra',
    value: '321'
  }
];

export const countries_pt = [
  {
    label: 'Portugal',
    value: '15'
  },
  {
    label: 'Açores',
    value: '15'
  },
  {
    label: 'Madeira',
    value: '15'
  }
];

export const countries_it = [
  {
    label: 'ITALIA',
    value: '11'
  }
];

export const countries_al = [
  {
    label: 'ALBANIA',
    value: '324'
  }
];

export const countries_rs = [
  {
    label: 'SERBIAN REPUBLIC',
    value: '95'
  }
];

export const countries_ro = [
  {
    label: 'ROMANIA',
    value: '13'
  }
];

export const countries_gr = [
  {
    label: 'GREECE',
    value: '62'
  }
];

export const countries_uk = [
  {
    label: 'UKRAINA',
    value: '90'
  }
];

export const countries_br = [
  {
    label: 'Brazil',
    value: '45'
  }
];